module.exports = __webpack_public_path__ + "static/media/buildIcon@3x.4e1db378.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customization/components/Customize/assets/buildIcon@3x.png
// module id = 703
// module chunks = 0